<template>
  <div>
    <NavBar />
    <b-overlay :show="loading" opacity="0.99">
      <b-container>
        <errors-messages :errors="errors" />
        <b-row>
          <b-col>
            <v-data-table dense :headers="headers" :items="payment_terms">
              <template v-slot:[`item.active`]="{ item }">
                {{ item.active ? "ATIVO" : "INATIVO" }}
              </template>
            </v-data-table>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import api from "../services/api";
import ErrorsMessages from "../templates/components/ErrorsMessages.vue";
import NavBar from "../templates/NavBar";

export default {
  name: "PaymentTerms",
  components: {
    NavBar,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],

      headers: [
        { text: "Código", value: "id" },
        { text: "Nome", value: "name" },
        { text: "Descrição", value: "description" },
        { text: "Valor", value: "value" },
        { text: "status", value: "active" },
      ],
      payment_terms: [],

      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {
      try {
        this.loading = true;

        let response = await api.get("/payment-terms");
        let { error, errors, payment_terms } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.payment_terms = payment_terms;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>